export const LOGIN_FALLBACK = 'Log In'
